import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class RepetitionSkipAllowedOnlyForMonthlyScheduleError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.repetition-skip.allowed-only-for-monthly-schedule');
    }
}
